module.exports = __webpack_public_path__ + "static/media/logoz.62195e85.png";